/**
 * Restores session from localStorage token on app load.
 * Ensures isInitialized is set so ProtectedRoute does not hang forever.
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { getCurrentUser, setInitialized } from '../../store/slices/authSlice';

const AuthBootstrap: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { token, user, isInitialized, isLoading } = useSelector(
    (state: RootState) => state.auth
  );

  useEffect(() => {
    if (isInitialized) return;

    if (!token) {
      dispatch(setInitialized());
      return;
    }

    if (user) {
      dispatch(setInitialized());
      return;
    }

    dispatch(getCurrentUser())
      .unwrap()
      .catch(() => {
        // getCurrentUser.rejected already clears auth
      })
      .finally(() => {
        dispatch(setInitialized());
      });
  }, [dispatch, token, user, isInitialized]);

  // Brief block only while restoring session
  if (!isInitialized && token && isLoading) {
    return null;
  }

  return <>{children}</>;
};

export default AuthBootstrap;
